export default "__VITE_ASSET__Bhc5GO5r__"